import { type ComponentProps, type FC } from "react";
import CreatableSelect from "react-select/creatable";
import { colors, fontSize } from "@root/shared/styles/sprinkles.css";

type Props = ComponentProps<typeof CreatableSelect>;

/*
  参考：https://react-select.com/home#custom-styles
*/
const customStyles = {
  control: <T extends Record<string, unknown>>(styles: T): T => ({
    ...styles,
    fontSize: fontSize["fs-14"],
    minHeight: "none",
    padding: "0 0 0 6px",
    border: "1px solid #aaa",
    borderRadius: "2px",
    boxShadow: "inset 1px 1px 1px #eee",
    lineHeight: 1.5,
  }),
  valueContainer: <T extends Record<string, unknown>>(styles: T): T => ({
    ...styles,
    padding: 0,
  }),
  input: <T extends Record<string, unknown>>(styles: T): T => ({
    ...styles,
    height: "auto",
    margin: 0,
    padding: 0,
  }),
  placeholder: <T extends Record<string, unknown>>(styles: T): T => ({
    ...styles,
    color: colors.TextLight,
  }),
  menu: <T extends Record<string, unknown>>(styles: T): T => ({
    ...styles,
    position: "relative",
  }),
  singleValue: <T extends Record<string, unknown>>(styles: T): T => ({
    ...styles,
    color: colors.TextDark,
  }),
};

export const InputTypeSelectBox: FC<Props> = ({ ...rest }) => {
  return (
    <CreatableSelect {...rest} isClearable isValidNewOption={() => false} styles={customStyles} />
  );
};
